// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import * as L from "leaflet";

const path = '/assets/Environment/appsettings.Development.json';

function loadJSON(filePath) {
    const json = loadTextFileAjaxSync(filePath, 'application/json');
    return JSON.parse(json);
}

function loadTextFileAjaxSync(filePath, mimeType) {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', filePath, false);
    if (mimeType != null) {
        if (xmlhttp.overrideMimeType) {
            xmlhttp.overrideMimeType(mimeType);
        }
    }
    xmlhttp.send();
    if (xmlhttp.status === 200) {
        return xmlhttp.responseText;
    } else {
        return null;
    }
}

const appsettings = loadJSON(path);

export const environment = {
    production: appsettings.Settings.Production,
    mapSettings: {
        homeIcon: new L.Icon({
            iconUrl: appsettings.Settings.MapSettings.HomeIcon.IconUrl,
            iconSize: [
                appsettings.Settings.MapSettings.HomeIcon.IconSize.X,
                appsettings.Settings.MapSettings.HomeIcon.IconSize.Y
            ],
            iconAnchor: [
                appsettings.Settings.MapSettings.HomeIcon.IconAnchor.X,
                appsettings.Settings.MapSettings.HomeIcon.IconAnchor.Y
            ],
            popupAnchor: [
                appsettings.Settings.MapSettings.HomeIcon.PopupAnchor.X,
                appsettings.Settings.MapSettings.HomeIcon.PopupAnchor.Y
            ]
        }),
        markerIcon: new L.Icon({
            iconUrl: appsettings.Settings.MapSettings.MarkerIcon.IconUrl,
            iconSize: [
                appsettings.Settings.MapSettings.MarkerIcon.IconSize.X,
                appsettings.Settings.MapSettings.MarkerIcon.IconSize.Y
            ],
            iconAnchor: [
                appsettings.Settings.MapSettings.MarkerIcon.IconAnchor.X,
                appsettings.Settings.MapSettings.MarkerIcon.IconAnchor.Y
            ],
            popupAnchor: [
                appsettings.Settings.MapSettings.MarkerIcon.PopupAnchor.X,
                appsettings.Settings.MapSettings.MarkerIcon.PopupAnchor.Y
            ]
        }),
        mapOptions: {
            center: [
                appsettings.Settings.MapSettings.MapOptions.Center.Latitude,
                appsettings.Settings.MapSettings.MapOptions.Center.Longitude
            ],
            minZoom: appsettings.Settings.MapSettings.MapOptions.MinZoom,
            maxZoom: appsettings.Settings.MapSettings.MapOptions.MaxZoom,
            zoom: appsettings.Settings.MapSettings.MapOptions.Zoom,
            zoomControl: appsettings.Settings.MapSettings.MapOptions.ZoomControl
        },
        tileServerSettings: {
            urlTemplate: appsettings.Settings.MapSettings.TileServerSettings.UrlTemplate,
            urlParameters: {
                baseUrl: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.BaseUrl,
                path: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.Path,
                resource: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.Resource,
                mapId: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.MapId,
                scheme: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.Scheme,
                size: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.Size,
                format: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.Format,
                appId: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.AppId,
                appCode: appsettings.Settings.MapSettings.TileServerSettings.UrlParameters.AppCode
            },
        }
    },
    serviceUrl: appsettings.Settings.ServiceUrl,
    applicationInsights:
    {
        instrumentationKey: appsettings.Settings.ApplicationInsights.InstrumentationKey
    }
};



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/environment/environment.ts